/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React from "react";
import { graphql } from "gatsby";
import BannerSection from "~components/sections/BannerSection.jsx";
import PartnersLarge from "~components/sections/PartnersLarge";
import FourColumnLinks from "~components/sections/FourColumnLinks";
import SEO from "~components/SEO.jsx";
import Footer from "~components/Footer.jsx";
import Layout from "~components/Layout.jsx";
import PartnersSmall from "../components/sections/PartnersSmall";

const PartnersPage = ({ data, location }) => {
  const cms = data.sanityPartnersPage;

  return (
    <>
      <SEO
        customTitle={cms?.title}
        customDescription={cms?.seoDescription}
        customKeywords={cms?.seoKeywords}
        path={location.pathname}
      />

      <Layout>
        <BannerSection data={cms.atfBanner} />

        <PartnersLarge
          heading={cms.primaryPartners.header}
          subheading={cms.primaryPartners.subheader}
          partners={cms.primaryPartners.partners}
        />
        <PartnersSmall
          heading={cms.secondaryPartners.header}
          subheading={cms.secondaryPartners.subheader}
          partners={cms.secondaryPartners.partners}
        />
        <PartnersSmall
          heading={cms.tertiaryPartners.header}
          subheading={cms.tertiaryPartners.subheader}
          partners={cms.tertiaryPartners.partners}
        />

        <FourColumnLinks data={cms.communityPartners} />
      </Layout>

      <Footer />
    </>
  );
};

export default PartnersPage;

export const query = graphql`
  query PartnersPage {
    sanityPartnersPage {
      title

      #

      atfBanner {
        textColor {
          hex
        }
        backgroundColor {
          hex
        }
        header
        subheader
        image {
          altText
          asset {
            gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
          }
        }
      }

      #

      primaryPartners {
        header
        subheader
        partners {
          name
          link
          infoText
          _key
          logo {
            asset {
              gatsbyImageData
            }
          }
        }
      }

      #

      secondaryPartners {
        header
        subheader
        partners {
          name
          link
          infoText
          _key
          logo {
            asset {
              gatsbyImageData
            }
          }
        }
      }

      #

      tertiaryPartners {
        header
        subheader
        partners {
          name
          link
          infoText
          _key
          logo {
            asset {
              gatsbyImageData
            }
          }
        }
      }

      #

      communityPartners {
        subheader
        header
        textColor {
          hex
        }
        backgroundColor {
          hex
        }
        links {
          url
          text
          _key
        }
      }

      #

      seoDescription
      seoKeywords
    }
  }
`;
